module.exports = __webpack_public_path__ + "media/images/thumbnails/thumbs_standalone-4bc24c8eeeff546e4f04ad2a86ede3d5.jpg";